import { Buffer } from "buffer";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { SecretNetworkClient } from "secretjs";

import { useToken } from "./useToken";
import { useConfig } from "./useConfig";
import { defaultGas, sleepTime } from "../utils/constants";
import { walletState } from "../context/walletState";
import { PairQueryContract } from "./clients/PairContract";
import { queryClientState } from "../context/queryClientState";
import { coinConvert, sleep, TxnLinkComp } from "../utils/common";
import { RouterContract, RouterQueryContract } from "./clients/RouterContract";

export const useRoute = () => {
  const { queryClient } = useRecoilValue(queryClientState);
  const { client, address } = useRecoilValue(walletState);
  const token = useToken();
  const config = useConfig();
  const routerQueryClient = new RouterQueryContract(
    queryClient as SecretNetworkClient,
    config.getOtherContract("router").contract_addr,
    config.getOtherContract("router").contract_code_hash
  );

  // TODO: use this later when writing a generalised router
  // let finalPaths: any[] = [];
  // let explored = new Set();
  // let count = 0;
  // let mp = new Map();

  // // Graph which contains all the paths
  // let allPaths = new Map();
  // // pair map contains pair information accessible by token address as key
  // // key for SCRT is uscrt
  // let pairMap = new Map();
  // // Store token information
  // let tokenInfo = new Map();
  // // Store simulation information for all the paths
  // let quoteInfo = new Map();

  const checkQueryClient = async () => {
    // while (true) {
    //   if (queryClient === undefined) {
    //     await sleep(sleepTime);
    //   } else {
    //     break;
    //   }
    // }
  }

  const checkTxnClient = async () => {
    // while (true) {
    //   if (client === undefined) {
    //     await sleep(sleepTime);
    //   } else {
    //     break;
    //   }
    // }
  }

  // const _calculatePathQuote = async (
  //   path: any[],
  //   inputAmount: number,
  // ) => {
  //   console.log(path, path.length);
  //   console.log(pairMap);
  //   let curAmount = inputAmount;
  //   let res;
  //   for (let i = 0; i < path.length - 1; i++) {
  //     let key = { token1: path[i], token2: path[i + 1] };
  //     console.log(key);
  //     let pair = pairMap.get(path[i] + path[i+1]);
  //     console.log(pair);

  //     const pairQueryClient = new PairQueryContract(
  //       queryClient as SecretNetworkClient,
  //       pair.contract_addr,
  //       pair.contract_code_hash,
  //     );

  //     const quote = await pairQueryClient.simulation({
  //       offerAsset: {
  //         info: tokenInfo.get(path[i]),
  //         amount: String(curAmount),
  //       }
  //     });
  //     res = quote;
  //     curAmount = quote.return_amount;
  //   }
  //   return res;
  // }

  // const _dfs = async (
  //   current: string,
  //   path: string[],
  //   tokenOut: string,
  // ) => {
  //   let pathCopy = JSON.parse(JSON.stringify(path));
  //   if (current == tokenOut) {
  //     mp.set(count++, pathCopy);
  //     finalPaths.push(pathCopy);
  //     return;
  //   }
  //   explored.add(current);
  //   for (let x of allPaths.get(current)) {
  //     if (!explored.has(x)) {
  //       pathCopy.push(x);
  //       _dfs(x, pathCopy, tokenOut);
  //     }
  //   }
  // }

  // const _locatePath = async (
  //   current: string,
  //   path: string[],
  //   tokenOut: string,
  // ) => {
  //   let pathCopy = JSON.parse(JSON.stringify(path));
  //   if (current == tokenOut) {
  //     mp.set(count++, pathCopy);
  //     finalPaths.push(pathCopy);
  //     return;
  //   }
  //   explored.add(current);
  //   for (let x of allPaths.get(current)) {
  //     if (!explored.has(x)) {
  //       pathCopy.push(x);
  //       _locatePath(x, pathCopy, tokenOut);
  //     }
  //   }
  // }

  /*
   * Returns swap path and rate from inputToken to outputToken using router contract
   */
  // const getSwapPath = async (
  //   inputToken: string,
  //   outputToken: string,
  //   inputAmount: string
  // ) => {
  //   await checkQueryClient();

  //   const pairsInfo = config.getPoolsList();
  //   for (const pool of pairsInfo) {
  //     const firstToken = config.getPoolsFirstAsset(pool.pair_name);
  //     const secondToken = config.getPoolsSecondAsset(pool.pair_name);

  //     let key = (
  //       (firstToken.contract_addr ?? firstToken.denom) +
  //       (secondToken.contract_addr ?? secondToken.denom)
  //     );
  //     let back_key = (
  //       (secondToken.contract_addr ?? secondToken.denom) +
  //       (firstToken.contract_addr ?? firstToken.denom)
  //     );

  //     let token0 = firstToken.contract_addr ?? firstToken.denom;
  //     let token1 = secondToken.contract_addr ?? secondToken.denom;
  //     tokenInfo.set(token0, firstToken);
  //     tokenInfo.set(token1, secondToken);

  //     let res = allPaths.get(token0) ?? [];
  //     res.push(token1);
  //     allPaths.set(token0, res);

  //     res = allPaths.get(token1) ?? [];
  //     res.push(token0);
  //     allPaths.set(token1, res);

  //     pairMap.set(key, pool);
  //     pairMap.set(back_key, pool);
  //   }

  //   console.log(allPaths);
  //   console.log(pairMap);

  //   // inputToken, [inputToken], outputToken
  //   await _dfs(
  //     inputToken,
  //     [inputToken],
  //     outputToken,
  //   );
  //   console.log(finalPaths);

  //   // console.log(mp);
  //   for (let route of finalPaths) {
  //     let finalAmount = await _calculatePathQuote(
  //       route,
  //       parseInt(coinConvert(inputAmount, 6, "machine")),
  //     );
  //     console.log("finalAmount: ", finalAmount);
  //   }
  // }

  /*
   * Returns swap rate from inputToken to outputToken using pair contract
   */
  const getSwapRate = async (
    inputToken: string,
    outputToken: string,
    inputAmount: string
  ): Promise<{
    tokenPath: string[],
    outputAmount: string,
  }> => {
    await checkQueryClient();

    let tokenPath = [inputToken];

    if(!(inputToken.startsWith("axl") && outputToken.startsWith("axl"))) {
      if (inputToken === "axlUSDT" && outputToken !== "axlUSDC") {
        tokenPath.push("axlUSDC");
      }

      if (inputToken !== "sSCRT" && outputToken !== "sSCRT") {
        tokenPath.push("sSCRT");
      }

      if (outputToken === "axlUSDT" && inputToken !== "axlUSDC") {
        tokenPath.push("axlUSDC");
      }
    }
    tokenPath.push(outputToken);

    let swapOperations = [];
    for (let idx = 0; idx < tokenPath.length-1; idx++) {
      const currentInputToken = tokenPath[idx];
      const currentOutputToken = tokenPath[idx+1];
      swapOperations.push(
        {
          astro_swap: {
            offer_asset_info: {
              contract_addr: config.getAsset(currentInputToken).contract_addr,
              contract_code_hash:
                config.getAsset(currentInputToken).contract_code_hash,
              denom: config.getAsset(currentInputToken).native_denom,
            },
            ask_asset_info: {
              contract_addr: config.getAsset(currentOutputToken).contract_addr,
              contract_code_hash:
                config.getAsset(currentOutputToken).contract_code_hash,
              denom: config.getAsset(currentOutputToken).native_denom,
            },
          },
        }
      )
    }

    try {
      const swapInfo = await routerQueryClient.simulateSwapOperations({
        offerAmount: coinConvert(inputAmount, 6, "machine"),
        operations: swapOperations,
      });

      return {
        tokenPath: tokenPath,
        outputAmount: coinConvert(swapInfo?.amount, 6, "human")
      };
    } catch (error) {
      console.debug(error);
      return {
        tokenPath: [],
        outputAmount: ""
      };
    }
  };

  /*
   * Returns config (factory address) using router contract
   */
  const getConfig = async () => {
    await checkQueryClient();

    try {
      const routerConfig = await routerQueryClient.config();
      return routerConfig;
    } catch (error) {
      console.debug(error);
    }
  };

  /*
   * Swaps inputToken to outputToken using router rontract
   */
  const doSwap = async (
    inputToken: string,
    outputToken: string,
    inputAmount: string,
    slippagePercentage: string,
    gasValue?: string | undefined
  ) => {
    await checkTxnClient();
    const tid = "Request Rejected";

    let tokenPath = [inputToken];

    if(!(inputToken.startsWith("axl") && outputToken.startsWith("axl"))) {
      if (inputToken === "axlUSDT" && outputToken !== "axlUSDC") {
        tokenPath.push("axlUSDC");
      }

      if (inputToken !== "sSCRT" && outputToken !== "sSCRT") {
        tokenPath.push("sSCRT");
      }

      if (outputToken === "axlUSDT" && inputToken !== "axlUSDC") {
        tokenPath.push("axlUSDC");
      }
    }
    tokenPath.push(outputToken);

    let swapOperations = [];
    for (let idx = 0; idx < tokenPath.length-1; idx++) {
      const currentInputToken = tokenPath[idx];
      const currentOutputToken = tokenPath[idx+1];
      swapOperations.push(
        {
          astro_swap: {
            offer_asset_info: {
              contract_addr: config.getAsset(currentInputToken).contract_addr,
              contract_code_hash:
                config.getAsset(currentInputToken).contract_code_hash,
              denom: config.getAsset(currentInputToken).native_denom,
            },
            ask_asset_info: {
              contract_addr: config.getAsset(currentOutputToken).contract_addr,
              contract_code_hash:
                config.getAsset(currentOutputToken).contract_code_hash,
              denom: config.getAsset(currentOutputToken).native_denom,
            },
          },
        }
      )
    }

    const routerClient = new RouterContract(
      client as SecretNetworkClient,
      config.getOtherContract("router").contract_addr,
      config.getOtherContract("router").contract_code_hash
    );

    try {
      if (config.getAsset(inputToken).native_denom !== null) {
        // native token
        const swapResponse = await routerClient.executeSwapOperations(
          {
            userAddress: address as string,
            customFees: {
              gas: gasValue !== undefined ? gasValue : defaultGas.native_swap,
              amount: [],
            },
            transferAmount: [
              {
                amount: coinConvert(inputAmount, 6, "machine"),
                denom: config.getAsset(inputToken).native_denom as string,
              },
            ],
          },
          {
            maxSpread: slippagePercentage,
            operations: swapOperations,
          }
        );

        if(swapResponse.code){
          toast.info("Swap failed", {
            type: "error",
            closeOnClick: true,
            autoClose: 5000,
          });
          if((swapResponse.rawLog).includes("exceeds max spread")){
            toast.info(("slippage value is less than required"), {
              type: "error",
              closeOnClick: true,
              autoClose: 5000,
            });
          }
          else {
            toast.info(((swapResponse.rawLog).substr(0,100) + "..."), {
              type: "error",
              closeOnClick: true,
              autoClose: 5000,
            });
          }
          toast.info(
            swapResponse.transactionHash
              ? TxnLinkComp(swapResponse.transactionHash)
              : "No hash",
            {
              closeOnClick: false,
            }
          );
        }

        else{
          toast.info("Swaped successfully", {
            type: "success",
            closeOnClick: true,
            autoClose: 5000,
          });
          toast.info(
            swapResponse.transactionHash
              ? TxnLinkComp(swapResponse.transactionHash)
              : "No hash",
            {
              closeOnClick: false,
            }
          );
        }
        return swapResponse;
      } else {
        // snip20 token
        const swapMsg = {
          execute_swap_operations: {
            max_spread: slippagePercentage,
            operations: swapOperations,
          },
        };
        const swapResponse = await token.doSend(
          inputToken,
          inputAmount,
          routerClient.contractAddress,
          routerClient.contractCodeHash as string,
          Buffer.from(JSON.stringify(swapMsg)).toString("base64"),
          gasValue !== undefined ? gasValue : defaultGas.snip_swap
        );

        if(swapResponse.code || swapResponse===undefined){
          toast.success("Swap failed", {
            type: "error",
            closeOnClick: true,
            autoClose: 5000,
          });
          if((swapResponse.rawLog).includes("exceeds max spread")){
            toast.info(("Slippage value is less than required"), {
              type: "error",
              closeOnClick: true,
              autoClose: 5000,
            });
          }
          else {
            toast.info(((swapResponse.rawLog).substr(0,100) + "..."), {
              type: "error",
              closeOnClick: true,
              autoClose: 5000,
            });
          }
          toast.info(
            swapResponse.transactionHash
              ? TxnLinkComp(swapResponse.transactionHash)
              : "No hash",
            {
              closeOnClick: false,
            }
          );
        }
        else{
          toast.success("Swaped successfully", {
            type: "success",
            closeOnClick: true,
            autoClose: 5000,
          });
          toast.info(
            swapResponse.transactionHash
              ? TxnLinkComp(swapResponse.transactionHash)
              : "No hash",
            {
              closeOnClick: false,
            }
          );
        }
        return swapResponse;
      }
    } catch (error) {
      console.debug(error);
      toast.info(tid, {
        type: "error",
        closeOnClick: true,
        // render: "Request rejected",
        autoClose: 5000,
        isLoading: false,
      });
    }
  };

  return {
    // getSwapPath,
    getSwapRate,
    getConfig,
    doSwap,
  };
};
